import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { filter, map } from 'lodash';

import { ContentZonesService, LocaleService } from '@sm360/widget-commons-core-services';
import { AccountService } from '@sm360/widget-commons-general';
import { Quote } from '@sm360/widget-commons-vehicle';

import QuoteElement from 'commons-garage/components/Quotes/QuoteElement.jsx';

import CONSTANT from 'commons-garage/constants/constant.js';

import 'commons-garage/components/Quotes/Quotes.scss';

const {
    QuoteService: { QuoteService },
} = Quote;
const czGroupName = 'widget.login.bar.quotes';

class QuotesDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            quotes: [],
        };

        const contentZone = ContentZonesService.getContentZone(czGroupName, 'image');
        this.imageUrl = contentZone ? contentZone.getValue() : '';
    }

    componentWillReceiveProps(newProps) {
        if (newProps.isOpen && !this.props.isOpen) {
            if (AccountService.isAuthenticated()) {
                QuoteService.getQuoteIds().then((response) => {
                    const promise = map(response.data, (quoteId) => {
                        return QuoteService.getQuote(quoteId);
                    });

                    axios.all(promise).then((quotes) => {
                        const filteredQuotes = filter(quotes.map((quote) => quote.data), (quote) => {
                            return (
                                quote.status === CONSTANT.QUOTE_STATUS.ACTIVE ||
                                quote.status === CONSTANT.QUOTE_STATUS.SOLD_WITH_DEPOSIT ||
                                quote.status === CONSTANT.QUOTE_STATUS.CREDIT_APPROBATION
                            );
                        });

                        this.setState({
                            quotes: filteredQuotes,
                        });
                    });
                });
            }
        }
    }

    render() {
        let quoteTransKey = '';
        let view;
        let className;
        const quotesLength = this.state.quotes.length;

        if (quotesLength > 1) {
            quoteTransKey = 'LOGIN.LOGIN_PREPARING_MULTI';
        } else if (quotesLength === 1) {
            quoteTransKey = 'LOGIN.LOGIN_PREPARING';
        }

        const quotes = this.state.quotes.map((quote) => <QuoteElement key={quote.id} quote={quote} />);

        if (quotesLength > 0) {
            className = 'pending-transactions';

            view = (
                <div className="dropdown-trigger">
                    <span className="pending-text">{LocaleService.t('LOGIN.PENDING_TRANSACTIONS')}</span>
                    <div className="dropdown">
                        <div className="dropdown-content">
                            <img className="pending-img" src={this.imageUrl} alt={LocaleService.t('LOGIN.PENDING')} />

                            <p className="label-preparing">{LocaleService.t(quoteTransKey)}</p>

                            <ul className="quote-listing">{quotes}</ul>
                        </div>
                    </div>
                </div>
            );
        }

        return <div className={className}>{view}</div>;
    }
}

QuotesDropdown.propTypes = {
    isOpen: PropTypes.bool.isRequired,
};

QuotesDropdown.displayName = 'QuotesDropdown';

export default QuotesDropdown;



// WEBPACK FOOTER //
// ./src/components/Quotes/QuotesDropdown.jsx